
import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom';
import '../cssstyle/Signup.css'
import { MdEmail } from "react-icons/md";
import { FaLock } from "react-icons/fa";
import { FaSquarePhone } from "react-icons/fa6";
import { FaSourcetree, FaUserFriends } from "react-icons/fa";
import ThemeToggle from '../jsstyle/ThemeToggle'
import LoadingSpin from '../../features/LoadingSpin';
import { SiIobroker } from "react-icons/si";
import "bootstrap/dist/css/bootstrap.min.css";
import '../cssstyle/Popup.css';
import { signupService } from '../apiservice/signupService';
import { toast } from 'react-toastify';
import { useGoogleAuth } from '../../context/GoogleAuthProvider';



//**Extra text for make it huminize */

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 


// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 


// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 


// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 



//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun





const Signup = () => {


    const optionsList = [
        'Zerodha',
        'Upstox',
        'Groww',
        'Angel One',
        '5paisa',
        'ICICI Direct',
        'HDFC Securities',
        'Kotak Securities',
        'Sharekhan',
        'Motilal Oswal',

        // Global Brokers
        'Robinhood',
        'eToro',
        'Interactive Brokers',
        'TD Ameritrade',
        'Fidelity',
        'Charles Schwab',
        'Webull',
        'Plus500',

        // Crypto Brokers
        'Binance',
        'Coinbase',
        'WazirX',
        'CoinDCX',
        'Kraken',
        'KuCoin',
        'Bitbns'
    ];

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [existUserLoadingState, setExistUserLoadingState] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [phonenumber, setPhonenumber] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [brokerInputValue, setBrokerInputValue] = useState("");
    const [source, setSourceValue] = useState();
    const [showDropdown, setShowDropdown] = useState(false);
    const [referralcode, setReferralcode] = useState('');
    const [conditions, setConditions] = useState('');
    const location = useLocation();

    const phoneNumber = "8684953093";
    const message = "Hello"
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const ref = queryParams.get('ref');
        if (ref) {
            setReferralcode(ref);
        }
    }, [location.search]);




    const validateData = ({ email = '', password = '', phonenumber = '', source = '', brokerInputValue = '', referralcode = '', conditions = '' }) => {
        if (!email || !password) {
            return "Email and password are required.";
        }

        if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email)) {
            return "Invalid email format.";
        }

        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@*()_+\-=\[\]{};':"\\|,.<>\/?]).+$/;

        // if (!regex.test(password)) {
        //     return "Password must contain at least one lowercase letter, one uppercase letter, one digit, and one special character.";


        // }

        if (password.length < 6) {
            return "Password must be at least 8 characters.";
        }


        if (!conditions) {
            return "You must accept the terms and conditions.";
        }

        if (
            email.length > 200 ||
            password.length > 200 ||
            phonenumber.length > 200 ||
            source.length > 200 ||
            brokerInputValue.length > 200 ||
            referralcode.length > 200
        ) {
            return "Input length should be less than 200 characters.";
        }

        return null;
    };

//  const { googleToken } = useGoogleAuth()


//  console.log("googletoken", googleToken)
    const handleFormSubmit = (e) => {
        e.preventDefault();

        try {
            const dataerror = validateData({
                email,
                password,
                phonenumber,
                source,
                brokerInputValue,
                referralcode,
                conditions,
            });

            if (dataerror) {

                throw new Error(dataerror)
            }
        }
        catch (error) {
            toast.warn(error.message)
            return;

        }

        setLoading(true);


        const data = {
            email,
            password,
            phonenumber,
            source,
            brokerInputValue,
            referralcode,
        };

        signupService(data)
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.error === true) {

                        toast.error(response?.data.data)

                    } else {

                        toast.success(response?.data?.data)
                    }
                } else {


                    toast.error(response?.data?.message)
                }

                setShowPopup(true);
                setTimeout(() => setShowPopup(false), 3000);
                setLoading(false);
            })
            .catch((error) => {

                toast.error(error?.response?.data?.message)
                setTimeout(() => setShowPopup(false), 4000);
                setLoading(false);
            });
    };




    const handleSelect = (option) => {
        setBrokerInputValue(option);
        setShowDropdown(false);
    };


    // Filter options based on user input (case-insensitive)
    const filteredOptions = optionsList.filter(option =>
        option.toLowerCase().includes(brokerInputValue.toLowerCase())
    );


    const alreadyUserLoading = () => {
        setExistUserLoadingState(true)
        setTimeout(() => {
            navigate('/login');
        },
            1000)
    }


    return (

        <div>

            <ThemeToggle />
            <div className='wrapper'>
                <form onSubmit={handleFormSubmit}>
                    <h1>Signup</h1>
                    <div className='input-box'>
                        <input type='text' placeholder='Email'

                            value={email}
                            onChange={(e) => setEmail(e.target.value)}></input>
                        <MdEmail className='icon'></MdEmail>

                    </div>
                    <div className='input-box'>
                        <input type='password' placeholder='Password'
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}></input>
                        <FaLock className='icon'></FaLock>


                    </div>

                    <div className='input-box'>
                        <input type='phone' placeholder='Phone Number'
                            value={phonenumber}
                            onChange={(e) => setPhonenumber(e.target.value)}></input>
                        <FaSquarePhone className='icon' />



                    </div>

                    {/* <div className="custom-combobox-group"> */}
                    <div className="input-box">



                        <input

                            type="text"
                            id="fruit"
                            className="custom-combobox-input"
                            placeholder="Type or select Fav Broker..."
                            value={brokerInputValue}
                            onChange={(e) => setBrokerInputValue(e.target.value)}
                            onFocus={() => setShowDropdown(true)}
                            autoComplete="off"
                        />

                        <SiIobroker className='input-icon' />

                        {showDropdown && filteredOptions.length > 0 && (
                            <ul className="custom-combobox-dropdown">
                                {filteredOptions.map((option, index) => (
                                    <li
                                        key={index}
                                        onClick={() => handleSelect(option)}
                                        className="custom-combobox-option"
                                    >


                                        {option}
                                    </li>


                                ))}

                            </ul>

                        )}


                    </div>

                    <div className=' input-box '>
                        <FaSourcetree className='icon' />


                        <select className='select-input'
                            value={source}
                            onChange={(e) => setSourceValue(e.target.value)}>



                            <option value=''>Select Source</option>
                            <option value='source 1'>Facebook</option>

                            <option value='source 2'>Youtube</option>
                            <option value='source 3'>Instagram</option>
                            <option value='source 4'>Twitter</option>
                            <option value='source 5'>SnapChat</option>




                        </select>

                    </div>
                    <div className='input-box'>
                        <label htmlFor="referralCodeInput" className="label">



                        </label>
                        <input
                            id="referralCodeInput"
                            name="referral"
                            type='text' placeholder='Referral Code'
                            value={referralcode}
                            onChange={(e) => setReferralcode(e.target.value)}></input>


                        <FaUserFriends className='input-icon'></FaUserFriends>

                    </div>




                    <div className='remember-forgot'>
                        <label>
                            <input type='checkbox'
                                value={conditions}
                                onChange={(e) => { setConditions(e.target.checked) }} />

                            I agreee the{" "}
                            <a href="https://www.algocontroller.com/terms_and_condition" target="_blank" rel="noopener noreferrer">
                                Terms and Conditions
                            </a>
                        </label>


                    </div>

                    <button
                        type="submit"

                        className="my-button"
                        disabled={loading}
                    >
                        {loading ? <div className="spinner-wrapper"><LoadingSpin /></div> : 'Signup'}
                    </button>




                    <div className="register-link">
                        <div>
                            Already have an account? {' '}
                            <span onClick={alreadyUserLoading} className={`signup-wrapper ${existUserLoadingState ? 'loading' : ''}`}>
                                <span className="signup-text">Login</span>
                                {existUserLoadingState && (
                                    <div className="spinner-overlay">
                                        <LoadingSpin />
                                    </div>
                                )}
                            </span>
                        </div>
                    </div>

                </form>



            </div>
            <div className="full-line"></div>

            <div className='terms-conditions'>
                <p>
                     <a href="https://www.algocontroller.com/terms-condition" target="_blank"
                        rel="noopener noreferrer" > Terms & Conditions</a>
                    <span> | </span>

                    <a href="https://www.algocontroller.com/privacy-policy" target="_blank"
                        rel="noopener noreferrer" >Privacy Policy</a>
                    <span> | </span>

                    {/* <a href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`} target="_blank"
                        rel="noopener noreferrer" >support@algocontroller.com</a> */}

                    <a
                        rel="noopener noreferrer" >support@algocontroller.com</a>


                </p>
            </div>




        </div>


    )
}

export default Signup